export const PLUGINS = {
  toolbar: {
    items: [
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'subscript',
      'superscript',
      'smallcaps',
      'removeFormat',
      'cut',
      '|',
      'insertLink',
      'specialCharacters',
      '|',
      'findandreplace',
      'trackchanges',
    ],
  },
  type: 'mini-editor',
  placeholder: 'Add a numbered or unnumbered reference to the document.',
};
